document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="http"]').forEach(link => {
    if (!link.href.includes(window.location.hostname)) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const today = new Date();

  function format(date) {
    return date.toLocaleString("en-US", { month: "short", day: "numeric" });
  }

  // timeline dates
  const orderPlaced = format(today);

  const dispatchStart = format(today);
  const dispatchEnd = format(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 6));

  const deliveryStart = format(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 9));
  const deliveryEnd = format(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 11));

  // inject HTML
  document.getElementById("delivery-timeline").innerHTML = `
    <div class="timeline-row">
      <div class="timeline-step">
      <div class="step-box">
        <img src="https://cdn.shopify.com/s/files/1/0461/3937/5778/files/package_1429c890-4b46-434b-a2f1-3244f878e0ef.png" alt="">
      </div>
        <p><strong>${orderPlaced}</strong><br>Order Placed</p>
      </div>

      <div class="timeline-step">
      <div class="step-box">
        <img src="https://cdn.shopify.com/s/files/1/0461/3937/5778/files/tracking.png" alt="">
        </div>
        <p><strong>${dispatchStart} – ${dispatchEnd}</strong><br>Order Dispatches</p>
      </div>

      <div class="timeline-step">
      <div class="step-box">
        <img src="https://cdn.shopify.com/s/files/1/0461/3937/5778/files/delivery-man.png?v=1765521036" alt="">
         </div>
        <p><strong>${deliveryStart} – ${deliveryEnd}</strong><br>Estimated Delivery</p>
      </div>
    </div>
    `;
});